import {
  CONTENT_TYPE_BY_BODY_TYPE,
  DEFAULT_PAYLOAD_FIELDS,
  WEBHOOK_BODY_TYPES,
  WEBHOOK_INTEGRATION_TYPE,
} from './webhookData';

const webhookState = () => ({
  data: {
    title: '',
    description: '',
    integrationData: {
      type: WEBHOOK_INTEGRATION_TYPE,
      endpointUrl: '',
      headers: [
        {
          key: 'Content-Type',
          value: CONTENT_TYPE_BY_BODY_TYPE[WEBHOOK_BODY_TYPES.JSON],
        },
      ],
      body: {
        type: WEBHOOK_BODY_TYPES.JSON,
        template: DEFAULT_PAYLOAD_FIELDS,
      },
    },
  },
  etc: {
    creationType: '',
    webhookStep: 0,
    integrationId: '',
  },
});

export const mapWebhookApiDataToState = apiData => ({
  title: apiData?.title || '',
  description: apiData?.description || '',
  integrationData: {
    type: apiData?.integrationData?.type || WEBHOOK_INTEGRATION_TYPE,
    endpointUrl: apiData?.integrationData?.endpointUrl || '',
    headers: apiData?.integrationData?.headers?.length
      ? apiData.integrationData.headers
      : webhookState().data.integrationData.headers,
    body: {
      type: apiData?.integrationData?.body?.type || WEBHOOK_BODY_TYPES.JSON,
      template: apiData?.integrationData?.body?.template?.length
        ? apiData.integrationData.body.template
        : DEFAULT_PAYLOAD_FIELDS,
    },
  },
});

export const buildWebhookIntegrationPayload = data => ({
  title: data.title,
  ...(data.description ? { description: data.description } : {}),
  integrationData: {
    type: WEBHOOK_INTEGRATION_TYPE,
    endpointUrl: data.integrationData.endpointUrl,
    headers: data.integrationData.headers,
    body: {
      type: data.integrationData.body.type,
      template: data.integrationData.body.template
        .filter(({ key }) => key)
        .map(({ fieldId, key, dataType }) => ({
          ...(fieldId ? { fieldId } : {}),
          key,
          dataType,
        })),
    },
  },
});

export default webhookState;
